module.exports = "<div class=\"dashboard-page\">\n\n    <stats></stats>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/dashboard-page.component.html
// module id = 250
// module chunks = 0